module.exports = __webpack_public_path__ + "static/media/blue_tiles.75a417a4.svg";